import { TOptions } from 'i18next';

import { NAME_SPACES } from '@/i18n/i18n';

export enum Language {
  English = 'en',
  Dutch = 'nl',
}

export type TNamespace = (typeof NAME_SPACES)[number];

export type NameSpaceType = TNamespace | TNamespace[];

export type TranslateOptions = TOptions & {
  checkKeyExists?: boolean;
};

export type TranslatorFunction = (
  key: string,
  options?: TranslateOptions,
) => string;
